import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import QR from 'qrcode.react';
import {
	Button,
	Tabs,
	Table,
	message,
	Spin,
	Select,
	Input,
	Icon,
	DatePicker,
	Modal,
} from 'antd';
import Wrapper from './style';
import Coins from '../../components/Coins';
import Popup from '../../components/Popup';

import {
	TABLE_TRANSACTION_COLUMN,
	TABLE_ADDRESS_COLUMN,
} from '../../config/constants';

import {
	getAsset,
	getTransaction,
	getWalletBalance,
	updateAsset,
	postAddress,
	withdraw,
	deleteWallet,
	requestAutoSweep,
	requestManualSweep,
	requestRestartWallet
} from '../../common/fetch';

import WalletModal from './WalletModal';
import UpgradeModal from '../../components/UpgradeModal';
import CheckTransaction from './CheckTransaction';

const { TabPane } = Tabs;

const defaultPagination = {
	current: 1,
	total: 0,
};

const dateFormat = 'YYYY/MM/DD';

class WalletDeatil extends Component {
	state = {
		isLoaded: false,
		tabStats: 'Transactions',
		dataTransaction: [],
		paginationTransaction: defaultPagination,
		paginationAddresses: defaultPagination,
		dataAddress: [],
		loading: false,
		modalType: '',
		url: '',
		visible: false,
		balance: 0,
		webhook: '',
		master: '',
		modalData: '',
		currency: 'btc',
		isRipple: false,
		is_testnet: false,
		isOpen: false,
		isCheck: false,
		checkData: {},
		address: '',
		type: '',
		startDate: '',
		endDate: '',
		needPin: false,
		isFetching: false,
		id: 0,
		autoSweep: false,
		sweepData: {}
	};

	componentDidMount() {
		const { state } = this.props.location;
		if (state && state.data) {
			this.setState(
				{
					webhook: state.data.webhook,
					currency: state.data.currency,
					isRipple: state.data.currency === 'xrp',
					is_testnet: state.data.is_testnet,
					type: state.data.type,
					id: state.data.id,
					autoSweep: state.data.auto_sweep
				},
				() => {
					this.getData();
				}
			);
		}
	}

	componentWillReceiveProps(next) {
		if (next.isDelete) {
			this.checkToDeleteWallet();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (JSON.stringify(prevProps.walletData)
			!== JSON.stringify(this.props.walletData)
				&& this.props.walletData.length
		) {
			let res = this.props.walletData.filter(data => data.id === this.state.id);
			if (res.length) {
				this.setState({ autoSweep: res[0].auto_sweep });
			}
		}
	}

	getData = async () => {
		const { location } = this.props;
		const arr = location.pathname.split('/');
		this.walletName = arr[arr.length - 1];

		const addresses = await this.getAddress(this.walletName);
		const walletInfo = await this.getBalance(this.walletName);
		const transactions = await this.getTransaction(this.walletName);
		const paginationTransaction = { ...this.state.paginationTransaction };
		paginationTransaction.total = transactions.count;
		const paginationAddresses = { ...this.state.paginationAddresses };
		paginationAddresses.total = addresses.count;
		this.setState({
			master: walletInfo.address,
			balance: walletInfo.balance,
			dataAddress: addresses.data,
			dataTransaction: transactions.data,
			paginationTransaction: paginationTransaction,
			paginationAddresses: paginationAddresses,
			isLoaded: true,
		});
	};

	getAddress = async (walletName, page = 1) => {
		try {
			const walletData = await getAsset(walletName, page);
			const dataAddress = walletData.data.data.sort((a, b) => {
				const AD = new Date(a.created_at);
				const BD = new Date(b.created_at);
				return AD >= BD ? -1 : 1;
			});
			return {
				data: dataAddress,
				count: walletData.data.count,
			};
		} catch (error) {
			return { data: [], count: 0 };
		}
	};

	getBalance = async (walletName) => {
		try {
			const resBalance = await getWalletBalance(walletName);
			return resBalance.data;
		} catch (error) {
			console.error(error);
			return {
				address: 'not found address',
				balance: '0.0',
			};
		}
	};

	getTransaction = async (walletName, page = 1, query = null) => {
		try {
			const transactionData = await getTransaction(walletName, page, query);
			return {
				data: transactionData.data.data,
				count: transactionData.data.count,
			};
		} catch (error) {
			console.error(error);
			return { data: [], count: 0 };
		}
	};

	handleChangeTabs = (key) => {
		this.setState({
			tabStats: key,
		});
	};

	handleOk = async (data, type) => {
		if (type === 'webhook') {
			try {
				await updateAsset(this.walletName, data);
				this.setState({
					webhook: data.url,
				});
				message.success('Successfully Updated the Webhook');
			} catch (error) {
				message.error('Failed to Update the Webhook');
			}
		} else if (type === 'withdraw') {
			this.body = {
				data: {
					address: data.address,
					amount: parseFloat(data.amount),
					meta: {},
				},
				fee: data.priority,
			};
			if (!data.amount) {
				this.body.data.amount = 0;
			}
			if (this.state.isRipple) {
				this.body.data.meta = {
					tag: data.tag,
				};
			}
			this.setState({
				needPin: true,
				pinType: 'withdraw',
			});
		}
		this.handleCancel();
	};

	withdrawWithPin = (body) => {
		this.setState(
			{
				isFetching: true,
			},
			async () => {
				try {
					this.body.pin = body;
					console.log(this.body);
					await withdraw(this.walletName, this.body);
					this.setState({
						tabStats: 'Transactions',
						needPin: false,
						isFetching: false,
					});
					message.success('Successfully withdrawn');
				} catch (error) {
					console.error(error.data);
					this.setState({
						isFetching: false,
					});
					message.error(error.data.message);
				}
			}
		);
	};

	checkToDeleteWallet = () => {
		const { balance } = this.state;
		if (balance === 0) {
			Modal.confirm({
				title: 'Confirm to Delete',
				content: 'Do you want to delete the wallet?',
				onOk: () => {
					this.setState({
						needPin: true,
						pinType: 'delete',
					});
				},
			});
		} else {
			Modal.warning({
				title: 'Here are some balacne!',
				content: 'Move balance to the other wallet first.',
			});
		}
	};

	deleteWallet = () => {
		this.setState(
			{
				isLoaded: false,
			},
			async () => {
				const { id } = this.state;
				const body = {
					wallet_id: id,
				};
				try {
					await deleteWallet(body);
					message.success('Successfully deleted');
					this.props.onDelte();
				} catch (error) {
					console.error(error);
				}
				this.setState({ needPin: false, isLoaded: true });
			}
		);
	};

	handleCancel = () => {
		this.setState({ visible: false, modalType: '' });
	};

	search = async () => {
		const query = {
			address: this.state.address,
			type: this.state.type,
			start_date: this.state.startDate,
			end_date: this.state.endDate,
		};
		try {
			const res = await this.getTransaction(this.walletName, 1, query);
			const paginationTransaction = { ...this.state.paginationTransaction };
			paginationTransaction.total = res.count;
			this.setState({
				dataTransaction: res.data,
				paginationTransaction,
			});
		} catch (error) {}
	};

	handleChange = (e) => {
		const { name, value } = e.target;
		this.setState({ [name]: value });
	};

	handleKeyPress = (e) => {
		if (e.which === 13) {
			this.search();
		}
	};

	handleDate = (v) => {
		this.setState(
			{
				startDate: v[0]._d,
				endDate: v[1]._d,
			},
			this.search
		);
	};

	handleSelect = (v) => {
		this.setState(
			{
				type: v,
			},
			this.search
		);
	};

	handleCange = (e) => {
		const { name, value } = e.target;
		const pinNumber = value
			.replace(new RegExp('[a-zA-Z-_]', 'g'), '')
			.slice(0, 1);
		this.setState(
			{
				[name]: pinNumber,
			},
			() => {
				if (pinNumber.length === 1) {
					if (name === 'pin6') {
						this.pin5.focus();
						this.withdrawWithPin(pinNumber);
						return;
					}
					this[name].focus();
				}
			}
		);
	};

	copyAddress = (e) => {
		const copyText = e.input;
		/* Select the text field */
		copyText.select();
		copyText.setSelectionRange(0, 99999); /*For mobile devices*/

		/* Copy the text inside the text field */
		document.execCommand('copy');
		message.info('Copy the address');
	};

	handleTableChange = async (pagination, filters, sorter, type) => {
		if (type === 'address') {
			const pager = { ...this.state.paginationAddresses };
			pager.current = pagination.current;
			try {
				const addresses = await this.getAddress(
					this.walletName,
					pagination.current
				);
				this.setState({
					paginationAddresses: pager,
					dataAddress: addresses.data,
				});
			} catch (error) {
				this.setState({
					paginationAddresses: pager,
				});
			}
		} else {
			const pager = { ...this.state.paginationTransaction };
			pager.current = pagination.current;
			try {
				const transaction = await this.getTransaction(
					this.walletName,
					pagination.current
				);
				this.setState({
					paginationTransaction: pager,
					dataTransaction: transaction.data,
				});
			} catch (error) {
				this.setState({
					paginationTransaction: pager,
				});
			}
		}
	};

	openModal = (type) => {
		this.setState({
			visible: true,
			modalType: type,
			modalData: type === 'webhook' ? this.state.webhook : '',
		});
	};

	checkTransaction = () => {
		this.setState({
			isCheck: true,
			checkData: this.props.location.state,
		});
	};

	closeTransaction = () => {
		this.setState({
			isCheck: false,
			checkData: null,
		});
	};

	handlePushTransaction = (data) => {
		this.setState({
			isCheck: false,
			checkData: null,
			tabStats: 'Transactions',
		});
	};

	newAddress = async () => {
		const { verification_level } = this.props.user;
		if (verification_level >= 3) {
			try {
				const { dataAddress } = this.state;
				const res = await postAddress(this.walletName);
				res.data.isNew = true;
				const data = dataAddress.map((item) => {
					if (item.isNew) {
						item.isNew = false;
					}
					return item;
				});
				const newData = [res.data].concat(data);
				message.success('Successfully Generated an address');
				const pager = { ...this.state.paginationAddresses };
				pager.total = pager.total + 1;
				this.setState({
					tabStats: 'Addresses',
					dataAddress: newData,
					paginationAddresses: pager,
				});
			} catch (error) {
				console.error(error);
			}
		} else {
			this.setState({ isOpen: true });
		}
	};

	requestSweep = async (data, type) => {
		try {
			if (type === 'auto') {
				const res = await requestAutoSweep(this.walletName, data);
				if (res && res.data) {
					this.setState({
						autoSweep: res.data.auto_sweep,
						sweepData: res.data
					});
					const process = res.data.auto_sweep ? 'enabled' : 'disabled';
					message.success(`Successfully ${process} auto sweep`);
				}
			} else {
				const res = await requestManualSweep(this.walletName, data);
				if (res.data.message) {
					message.success(res.data.message);
				} else {
					message.success(`Successfully started manual sweeping`);
				}
			}
		} catch (error) {
			if (error.data && error.data.message) {
				message.error(error.data.message);
			} else {
				message.error('Failed to process manual sweep');
			}
		}
		this.handleCancel();
	};

	requestRefresh = async () => {
		try {
			await requestRestartWallet(this.walletName);
			message.success(`Successfully restarted wallet`);
		} catch (error) {
			message.error('Fail to Refresh wallet');
		}
		this.handleCancel();
	};

	openSettings = () => {
		this.setState({
			visible: true,
			modalType: 'settings',
			modalData: {
				onDelete: this.checkToDeleteWallet,
				handleWebhook: this.handleOk,
				requestSweep: this.requestSweep,
				requestRefresh: this.requestRefresh
			}
		});
	};

	closeModal = () => {
		this.setState({ isOpen: false });
	};

	render() {
		const {
			isLoaded,
			dataTransaction,
			dataAddress,
			loading,
			visible,
			modalType,
			balance,
			webhook,
			modalData,
			master,
			currency,
			isRipple,
			is_testnet,
			isOpen,
			isCheck,
			checkData,
			needPin,
			type,
			autoSweep
		} = this.state;
		const { location } = this.props;
		const arr = location.pathname.split('/');
		this.walletName = arr[arr.length - 1];

		return (
			<Wrapper>
				<div className="holla-wallet-header">
					<div className="header-title">
						<strong>{this.walletName}:</strong>{' '}
						{`${balance} ${currency.toUpperCase()}`}
					</div>
					<div className="coin-wrapper">
						<Coins type={currency} />
						<span
							className={is_testnet ? 'label testnet' : 'label mainnet'}
						>
							{is_testnet ? 'Testnet' : 'Mainnet'}
						</span>
					</div>
					<div className="settings-wrap">
						<Button type="info" block onClick={this.openSettings}>
							Settings
							<Icon
								type="setting"
							/>
						</Button>
					</div>
					<div className="webhook-wrap">
						{this.state.type === 'single' ? (
							<div className="box">
								<QR value={master} size={78} />
							</div>
						) : (
							<div className="multi-address-info">
								<p>Master Address: {master}</p>
								{/* <p>
									Webhook: {webhook === '' ? 'No Webhook' : webhook}{' '}
									<span
										onClick={() => {
											this.openModal('webhook');
										}}
									>
										Edit
									</span>
								</p> */}
							</div>
						)}
						{this.state.type === 'single' ? (
							<p>
								Scan this QR code with your phone wallet app to send
								funds to.
							</p>
						) : null}
					</div>
					{this.state.type === 'single' ? (
						<div className="deposit-address">
							<b>Deposit Address:</b>
							<Input
								value={master}
								ref={(el) => {
									this.apiKey = el;
								}}
								addonAfter={
									<Icon
										type="copy"
										onClick={() => {
											this.copyAddress(this.apiKey);
										}}
									/>
								}
								readOnly
							/>
						</div>
					) : null}
					{this.state.type === 'single' ? (
						<div className="btn-wrapper">
							{/* <Button type="info" block onClick={this.checkTransaction}>
								CHECK TRANSACTION
							</Button> */}

							<Button
								type="primary"
								className="btn-center"
								block
								onClick={() => {
									this.openModal('withdraw');
								}}
							>
								WITHDRAW
							</Button>
						</div>
					) : (
						<div className="btn-wrapper multi">
							{/* <Button
								type="primary"
								block
								onClick={this.checkTransaction}
							>
								CHECK TRANSACTION
							</Button> */}

							<Button
								type="primary"
								className="btn-center"
								block
								onClick={() => {
									this.openModal('withdraw');
								}}
							>
								WITHDRAW
							</Button>

							<Button type="primary" block onClick={this.newAddress}>
								New Address
							</Button>
						</div>
					)}
				</div>
				<div className="wallet-container">
					{this.state.type === 'single' ? (
						<div className="holla-table-wrapper">
							<div className="filter-wrapper">
								<div className="holla-table-filter-container">
									<Select
										defaultValue="Type"
										onChange={this.handleSelect}
									>
										<Select.Option value="">All</Select.Option>
										<Select.Option value="deposit">
											Deposits
										</Select.Option>
										<Select.Option value="withdrawal">
											Withdrawal
										</Select.Option>
									</Select>
									<DatePicker.RangePicker
										defaultValue={[
											moment(this.startDate),
											moment(this.endDate),
										]}
										format={dateFormat}
										onChange={this.handleDate}
									/>
									<Input
										name="address"
										value={this.state.address}
										onChange={this.handleChange}
										onKeyPress={this.handleKeyPress}
										suffix={<Icon type="search" onClick={this.search} />}
									/>

								</div>
								<div>
									<Button type="info" block onClick={this.checkTransaction}>
										CHECK TRANSACTION
									</Button>
								</div>
							</div>
							<Table
								columns={TABLE_TRANSACTION_COLUMN}
								rowKey={(record) => record.id}
								dataSource={dataTransaction}
								loading={loading}
								pagination={this.state.paginationTransaction}
								onChange={(pagination, filters, sorter) => {
									this.handleTableChange(
										pagination,
										filters,
										sorter,
										'transaction'
									);
								}}
								expandedRowRender={(record) => {
									return (
										<div>
											<b>Transaction ID:</b> {record.txid}
										</div>
									);
								}}
							/>
						</div>
					) : (
						<Tabs
							activeKey={this.state.tabStats}
							onChange={this.handleChangeTabs}
							tabBarExtraContent={
								<Button type="info" block onClick={this.checkTransaction}>
									CHECK TRANSACTION
								</Button>
							}
						>
							<TabPane tab="Transactions" key="Transactions">
								<div className="holla-table-wrapper">
									<div className="holla-table-filter-container">
										<Select
											defaultValue="Type"
											onChange={this.handleSelect}
										>
											<Select.Option value="">All</Select.Option>
											<Select.Option value="deposit">
												Deposits
											</Select.Option>
											<Select.Option value="withdrawal">
												Withdrawal
											</Select.Option>
										</Select>
										<DatePicker.RangePicker
											defaultValue={[
												moment(this.startDate),
												moment(this.endDate),
											]}
											format={dateFormat}
											onChange={this.handleDate}
										/>
										<Input
											name="address"
											value={this.state.address}
											onChange={this.handleChange}
											onKeyPress={this.handleKeyPress}
											suffix={
												<Icon type="search" onClick={this.search} />
											}
										/>
									</div>
									<Table
										columns={TABLE_TRANSACTION_COLUMN}
										rowKey={(record) => record.id}
										dataSource={dataTransaction}
										loading={loading}
										pagination={this.state.paginationTransaction}
										onChange={(pagination, filters, sorter) => {
											this.handleTableChange(
												pagination,
												filters,
												sorter,
												'transaction'
											);
										}}
										expandedRowRender={(record) => {
											return (
												<div>
													<b>Transaction ID:</b> {record.txid}
												</div>
											);
										}}
									/>
								</div>
							</TabPane>
							<TabPane tab="Addresses" key="Addresses">
								<div className="holla-table-wrapper">
									<Table
										columns={TABLE_ADDRESS_COLUMN}
										rowKey={(record) => record.id}
										dataSource={dataAddress}
										loading={loading}
										pagination={this.state.paginationAddresses}
										onChange={(pagination, filters, sorter) => {
											this.handleTableChange(
												pagination,
												filters,
												sorter,
												'address'
											);
										}}
										// expandedRowRender={(record) => {
										// 	return (
										// 		<div>
										// 			<b>Transaction ID:</b> {record.txid}
										// 		</div>
										// 	);
										// }}
									/>
								</div>
							</TabPane>
						</Tabs>
					)}
				</div>
				{visible ? (
					<WalletModal
						visible={visible}
						modalType={modalType}
						modalData={modalData}
						webhook={webhook}
						autoSweep={autoSweep}
						type={type}
						master={master}
						handleOk={this.handleOk}
						isRipple={isRipple}
						balance={balance}
						handleCancel={this.handleCancel}
					/>
				) : null}
				{isCheck ? (
					<CheckTransaction
						visible={isCheck}
						checkData={checkData}
						handleCancel={this.closeTransaction}
						handleOk={this.handlePushTransaction}
					/>
				) : null}
				<UpgradeModal
					visible={isOpen}
					step={1}
					handleCancel={this.closeModal}
					handleOk={this.closeModal}
				/>
				<Popup
					visible={needPin}
					title="Pin Number"
					header="Check Pin Number"
					isLoading={this.state.isFetching}
					onOk={(body) => {
						if (this.state.pinType === 'withdraw') {
							this.withdrawWithPin(body);
						} else {
							this.deleteWallet(body);
						}
					}}
					onCancel={() => {
						this.setState({ needPin: false });
					}}
				/>
				{!isLoaded ? (
					<div className="spin-wrapper">
						<Spin size="large" />
					</div>
				) : null}
			</Wrapper>
		);
	}
}

export default withRouter(WalletDeatil);
